import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCharitiesArray } from '../../../redux/modules/qcd/qcd.selectors';

import './CharityList.scss';
import deleteImg from 'src/assets/images/qcd-delete.png';
import editImg from 'src/assets/images/qcd-edit-pencil.png';
import { openModal } from '../../../redux/modules/modals/actions';
import { DELETE_CHARITY_MODAL } from '../../../redux/modules/modals/modals.module';
import {
  ADD_CHARITY_MODAL,
  DELIVERY_MAIL_CHECK_TO_CHARITY,
} from '../../../settings/settings';

const CharityList = ({ deliveryMethod }) => {
  const charities = useSelector(getCharitiesArray);
  const dispatch = useDispatch();
  const charitiesNum = Object.keys(charities).length;
  return charitiesNum > 0 ? (
    <>
      {deliveryMethod === DELIVERY_MAIL_CHECK_TO_CHARITY && (
        <div className="charities-container">
          {charities.map((charity) => (
            <div className="charity-container">
              <div className="first-charity-line">
                <h1 className="charity-header">{charity.charityName}</h1>
                <div className="charity-buttons">
                  <button
                    onClick={() =>
                      dispatch(
                        openModal(DELETE_CHARITY_MODAL, {
                          charityID: charity.charityID,
                        })
                      )
                    }
                    className="delete-charity-button"
                  >
                    <img
                      src={deleteImg}
                      alt="delete icon"
                      className="delete-icon"
                    />
                  </button>
                  <span className="padding-line" />
                  <button
                    onClick={() =>
                      dispatch(
                        openModal(ADD_CHARITY_MODAL, {
                          deliveryMethod: deliveryMethod,
                          existingCharityName: charity.charityName,
                          existingAttention: charity.attention,
                          existingAddressLineOne: charity.addressLineOne,
                          existingAddressLineTwo: charity.addressLineTwo,
                          existingCity: charity.city,
                          existingState: charity.state,
                          existingZip: charity.zip,
                          existingZipExt: charity.zipExt,
                          charityID: charity.charityID,
                          editMode: true,
                        })
                      )
                    }
                    className="editing-charity-button"
                  >
                    <img
                      src={editImg}
                      alt="edit icon"
                      className="delete-icon"
                    />
                  </button>
                </div>
              </div>
              <div className="charity-info">
                {charity.attention && <p>Attention: {charity.attention}</p>}
                <p>{charity.addressLineOne}</p>
                <p>{charity.addressLineTwo}</p>
                <p>
                  {charity.city}, {charity.state} {charity.zip}{' '}
                  {charity.zipExt && <>- {charity.zipExt}</>}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
      {deliveryMethod !== DELIVERY_MAIL_CHECK_TO_CHARITY && (
        <div className="charities-container-mail-to-person">
          {charities.map((charity) => (
            <div className="charity-container">
              <div className="first-charity-line">
                <h1 className="charity-header">{charity.charityName}</h1>
                <div className="charity-buttons">
                  <button
                    onClick={() =>
                      dispatch(
                        openModal(DELETE_CHARITY_MODAL, {
                          charityID: charity.charityID,
                        })
                      )
                    }
                    className="delete-charity-button"
                  >
                    <img
                      src={deleteImg}
                      alt="delete icon"
                      className="delete-icon"
                    />
                  </button>
                  <span className="padding-line" />
                  <button
                    onClick={() =>
                      dispatch(
                        openModal(ADD_CHARITY_MODAL, {
                          deliveryMethod: deliveryMethod,
                          existingCharityName: charity.charityName,
                          existingAttention: charity.attention,
                          existingAddressLineOne: charity.addressLineOne,
                          existingAddressLineTwo: charity.addressLineTwo,
                          existingCity: charity.city,
                          existingState: charity.state,
                          existingZip: charity.zip,
                          existingZipExt: charity.zipExt,
                          charityID: charity.charityID,
                          editMode: true,
                        })
                      )
                    }
                    className="editing-charity-button"
                  >
                    <img
                      src={editImg}
                      alt="edit icon"
                      className="delete-icon"
                    />
                  </button>
                </div>
              </div>
              <div className="charity-info">
                <p>{charity.attention}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  ) : (
    <></>
  );
};

export default CharityList;
